<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card color="grey lighten-5">
        <v-card-title
          class="text-h5 primary white--text"
          v-text="`Confirmar dados da Inscrição`"
        />

        <!--Dados Do Aluno-->
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <span class="font-weight-medium"
                  ><strong>DADOS PESSOAIS:</strong></span
                >
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">Matrícula:</span>
                {{ student.codigo }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"
                  >Nome Completo:</span
                >
                {{ student.nome }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"
                  >Processo Judicial:</span
                >
                <span class="font-weight-medium">
                  {{
                    processoJudicial && processoJudicial.length
                      ? `n° ${processoJudicial}`
                      : "NÃO"
                  }}
                </span>
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">
                  Vulnerabilidade Social:</span
                >
                <span class="font-weight-medium">
                  {{ vulnerabilidadeSocial ? "SIM" : "NÃO" }}
                </span>
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">
                  Acolhimento Institucional:</span
                >
                <span class="font-weight-medium">
                  {{ acolhimentoInstitucional ? "SIM" : "NÃO" }}
                </span>
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> Rua:</span>
                {{ student.endereco.rua }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> N°:</span>
                {{ student.endereco.numero }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> Bairro:</span>
                {{ student.endereco.bairro }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> CEP:</span>
                {{ student.endereco.cep }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!--Dados Do Aluno FIM-->

        <!--TABELA RENDA FAMILIAR-->
        <v-col cols="12" class="mb-2 pt-0">
          <span class="font-weight-medium"
            ><strong>Grupo Familiar:</strong></span
          >
        </v-col>
        <v-data-table
          :headers="headers"
          :items="family"
          class="mt-n5"
          hide-default-footer
        ></v-data-table>
        <v-card-text class="py-0">
          <p class="text-h5 d-flex mt-5">
            Renda per capita:
            <span class="font-weight-medium ml-1"> {{ renda_atual || 0 }}</span>
          </p>
        </v-card-text>
        <!--TABELA RENDA FAMILIAR FIM-->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="$emit('close')">
            CANCELAR
          </v-btn>
          <v-btn color="green" text @click="$emit('save')">
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    renda_atual: {
      type: String,
      default: ""
    },
    student: {
      type: Object,
      default: () => {}
    },
    processoJudicial: {
      type: String,
      default: ""
    },
    vulnerabilidadeSocial: {
      type: Boolean,
      default: false
    },
    acolhimentoInstitucional: {
      type: Boolean,
      default: false
    },
    family: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      disabled: true,
      checkbox: true,
      headers: [
        {
          align: "start"
        },
        { text: "Parentesco", value: "kinship.nome" },
        { text: "Nome", value: "nome" },
        { text: "Renda (R$)", value: "income" }
      ]
    };
  }
};
</script>
